"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { IOrderPayment } from '../types/Order'
/**
 * 將 APP 格式的 payments 轉換至 API 需要的格式
 * @deprecated 只有 multipayOrder 用到但是這隻 API 已經沒有使用了
 */
function appPaymentsToApiPayments(appPayments) {
    return undefined;
    // const apiPayments = _.map(appPayments, (appPayment, index) => {
    //   const paidAmount = Number(appPayment.paidAmount)
    //   const amount = Number(appPayment.amount)
    //   const paymentTips = Number(appPayment.paymentTips)
    //   const change = Number(appPayment.change)
    //   return {
    //     id: appPayment.id,
    //     paymentMethod: appPayment.paymentMethod,
    //     paymentCharge: appPayment.paymentCharge,
    //     payload: appPayment.payload,
    //     gateway: appPayment.gateway,
    //     ref: appPayment.ref,
    //     amount: (paymentTips > 0 ? amount - paymentTips : amount - change),
    //     paidAmount: paidAmount,
    //     paymentTips: paymentTips,
    //     change: change,
    //     remark: appPayment.remark,
    //     isSended: appPayment.isSended,
    //     status: appPayment.status,
    //   }
    // }).filter(payment => !payment.isSended)
    // return { payments: apiPayments }
}
exports.default = appPaymentsToApiPayments;
//# sourceMappingURL=appPaymentsToApiPayments.js.map